import type { UserRole } from "../types/auth";

export function isFleetScopedRole(role: UserRole | undefined): boolean {
  return role === "fleet" || role === "user";
}

export function getDefaultPathForRole(role: UserRole | undefined): string {
  return isFleetScopedRole(role) ? "/live-map" : "/dashboard";
}
